import moment from 'moment';

const convertTimestampToISOString = (ts: string): string => {
    return moment(parseInt(ts) * 1000 ).toISOString()
}

export default {
    convertTimestampToISOString,
}
